import { ContentProps } from './Page.types';

const Content = ({ children, stickyStyle }: ContentProps) => {
  if (typeof children === 'function') {
    // TODO: children probably never get passed as a function, check and refactor
    // @ts-expect-error
    return children({ stickyStyle });
  } else {
    return children;
  }
};

Content.displayName = 'Page.Content';
export default Content;
